<template>
  <div>
    <NoneData
      v-if="!commodityList.length"
      style="background: #ffffff"
      propsText="该店铺暂无相似店铺信息"
      :height="6"
    />
    <div class="shop-commodity" v-else>
      <form action="/"></form>
      <div class="carrier-list-data">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多数据了哦~"
          @load="getTableData"
        >
          <div
            v-for="(item, index) of shopList"
            :key="item.itemId"
            class="new_item-default"
          >
            <div class="new_box">
              <div class="top_box" @click="to(item.link)">
                <div class="new_commodity-sort">{{ index + 1 }}</div>
                <avatar class="new_item-icon" :text="item.name" :src="item.img"></avatar>
                <div class="text">
                  <div class="name">
                    {{ item.name }}
                  </div>
                  <div class="shop">
                    星级购物评分 <span style="color: #ff5000;font-weight: 700;">{{item.star}}</span>
                  </div>
                  <div class="num">
                    <div class="num_box" v-for="val in item.category">
                      {{ val }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="bottom_box">
                <div class="box_pay">
                  <div class="txt_1">近30天关联商品数</div>
                  <div class="txt_2">{{item.commodityCount}}</div>
                </div>
                <div class="box_pay">
                  <div class="txt_1">近30天关联达人</div>
                  <div class="txt_2">{{item.anchorCount}}</div>
                </div>
                <div class="box_pay">
                  <div class="txt_1">近30天关联销售额</div>
                  <div class="txt_2" style="color: #ff5000">{{item.sales}}</div>
                </div>
              </div>
              <div class="shop_botton"  @click="to(item.goodsLink)">
                <avatar class="img" :text="item.goodsName" :src="item.goodsImg"></avatar>
                <div class="txt">
                  <div class="name">
                    {{item.goodsName}}
                  </div>
                  <div class="pay">
                    <span>价格 {{item.goodsPrice}}</span>
                    <span>销售额 {{item.goodsSales}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </van-list>
      </div>
    </div>
  </div>
</template>

<script>
import avatar from '@/components/Avatar.vue'
export default {
  props: { query: Object },
  data() {
    return {
      loading: true,
      commodityList: [],
    };
  },
  watch: {
    query: {
      deep: true,
      immediate: true,
      handler() {
        this.getTableData();
      },
    },
  },
  computed: {
    finished: (_this = this) => true,
    shopList() {
      return this.commodityList.map((ele) => {
        return {
          ...ele,
          img: ele?.shop?.logo ? ele?.shop?.logo : this.$defaultSrc, // 图片
          name: ele?.shop?.name || "-", // 名称
          star: ele?.shop?.score || "-", // 星级
          category: ele?.category ? ele?.category.map((ele) => ele.name) : [], // 类目信息

          isFastReplySeller: ele?.shop?.isFastReplySeller === 1, // 极速回复
          isGoldCSSeller: ele?.shop?.isGoldCSSeller === 1, // 金牌客服
          isSellingTalentSeller: ele?.shop?.isSellingTalentSeller === 1, // 卖货达人
          isSellingMasterSeller: ele?.shop?.isSellingMasterSeller === 1, // 卖货大师
          isBrand: ele?.shop?.isBrand === 1, // 品牌店
          // isFlagship:ele?.shop?.isFlagship === 1, // 旗舰店
          isHighQualityAnchor: ele?.shop?.isHighQualityAnchor === 1, //优质商家

          avgCommodityPrice: ele.avgCommodityPrice
            ? "¥" + this.$retainWan(ele.avgCommodityPrice)
            : "-", // 商品均价
          commodityCount: ele.commodityCount
            ? this.$retainWan(ele.commodityCount)
            : "-", // 商品数
          anchorCount: ele.anchorCount ? this.$retainWan(ele.anchorCount) : "-", // 关联达人
          liveCount: ele.liveCount ? this.$retainWan(ele.liveCount) : "-", // 关联直播
          salesVolume: ele.salesVolume ? this.$retainWan(ele.salesVolume) : "-", // 销量
          sales: ele.sales ? "¥" + this.$retainWan(ele.sales) : "-", // 销售额
          goodsImg: ele?.commodity?.commodityImageUrl || this.$defaultSrc, // 商品图片
          goodsName: ele?.commodity?.commodityTitle || "-", // 商品名称
          goodsPrice: ele?.commodity?.commodityPrice
            ? "¥" + this.$retainWan(ele?.commodity?.commodityPrice)
            : "-", // 商品价格
          goodsSales: ele?.commodity?.commoditySales
            ? "¥" + this.$retainWan(ele?.commodity?.commoditySales)
            : "-", // 商品销售额
          goodsLink: ele?.commodity?.itemId
            ? `/goods/${ele.commodity.itemId}`
            : "", // 商品链接
          link: ele?.shop?.id ? `/shop/${ele?.shop?.id}` : "", //链接
        };
      });
    },
  },
  methods: {
    to(url){
        if(url) {
            this.$router.push({path:url})
        }
    },    
    async getTableData() {
      const res = await this.$api
        .get(`/v2/similarShop`, {
          params: { shopId: this.$route.params.id },
        })
        .catch((_) => {});

      this.commodityList = res.data;
    },
  },
};
</script>

<style scoped lang="less">
/deep/.van-search__content {
  border-radius: 10px;
}
.loading {
  font-size: 0.24rem;
  color: #fbfafa;
  padding: 0.5rem 0.3rem;
  text-align: center;
}
.new_item-default {
  font-family: number-bold, sans-serif;
  padding: 18px 0px 0 0px;
  background: #fff;
  box-shadow: 0px 0px 8px 8px rgba(168, 178, 197, 0.08);
  margin-bottom: 12px;
  display: flex;
  width: 375px;
  .new_box {
    display: flex;
    flex-direction: column;
    align-items: center;

    .top_box {
      padding: 0 12px;
      display: flex;
      position: relative;
      .new_commodity-sort {
        position: absolute;
        top: -5px;
        left: 6px;
        color: #2877ff;
        text-align: center;
        font-family: Roboto;
        font-size: 10px;
        font-style: normal;
        font-weight: 500;
        line-height: 12px; /* 120% */
      }
      .new_item-icon {
        margin-left: 10px;
        margin-right: 8px;
        width: 60px;
        height: 60px;
        border-radius: 8px;
        border: 1px solid #efefef;
        img {
          width: 100%;
        }
      }
      .text {
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .name {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          width: 267px;
          height: 20px;
          color: var(--, #252e39);
          font-family: PingFang SC;
          font-size: 14px;
          font-style: normal;
          font-weight: 500;
          line-height: normal;
        }
        .shop {
          height: 20px;
          font-family: number-bold, sans-serif;
          color: var(--unnamed, #8e9aae);
          font-size: 0.24rem;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
        }
        .num {
          display: flex;
          .num_box {
            padding: 1px 4px;
            color: #2877ff;
            text-align: center;
            font-family: PingFang SC;
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
            border-radius: 14px;
            background-color: rgba(55, 121, 246, 0.1);
            margin-right: 8px;
          }
        }
      }
    }
    .bottom_box {
      width: 351px;
      // padding: 0 12px;
      margin: 18px 0;
      display: flex;
      height: 60px;
      background: #fafafa;
      border-radius: 3px;
      .box_pay {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        align-items: center;
        .txt_1 {
          color: #8e9aae;
          text-align: center;
          font-family: PingFang SC;
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          line-height: 12px; /* 100% */
        }
        .txt_2 {
          color: #141b27;
          text-align: center;
          font-family: Roboto;
          font-size: 16px;
          font-style: normal;
          font-weight: 500;
          line-height: 16px; /* 100% */
        }
      }
    }
    .shop_botton {
      width: 100%;
      height: 72px;
      border-top: 1px solid #f2f2f2;
      padding: 0 12px;
      display: flex;
      align-items: center;
      .img {
        width: 40px;
        height: 40px;
        border-radius: 4px;
        border: 1px solid #e6e6e6;
        margin-right: 7px;
      }
      .txt {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 40px;
        .name {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          width: 300px;
          color: var(--, #252e39);
          font-family: PingFang SC;
          font-size: 14px;
          font-style: normal;
          font-weight: 500;
          line-height: normal;
        }
        .pay {
          span {
            font-family: number-bold, sans-serif;
            color: var(--unnamed, #8e9aae);
            font-size: 0.24rem;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
            margin-right: 16px;
          }
        }
      }
    }
  }
}
</style>
